export const STROKE_DASHARRAY = '6 4';
export const ARROW_SIZE = 10;
export const LINE_STYLE = ({
  DASHED: 'dashed',
  SOLID: 'solid'
} as const);
export type LineStyleT = (typeof LINE_STYLE)[keyof typeof LINE_STYLE];
export const LABEL_FONT_SIZE = 13;
export const LABEL_PADDING = 5;
export const LABEL_BORDER_RADIUS = 10;
export const LABEL_FONT_FAMILY = 'UberMoveText';
export const LABEL_TEXT_COLOR = 'white';
export const LABEL_BACKGROUND_COLOR = 'rgba(0, 0, 0, 0.75)';
export const DEFAULT_EDGE_COLOR = '#00BFFF';